import { useQuery } from '@tanstack/react-query';
import { getCurrentTariff } from '../api/user';
import { useAuthStore } from '../store/auth.store';

export function useCurrentTariff() {
  const userGUID = useAuthStore((s) => s.user?.guid);
  return useQuery({
    queryKey: ['tariff', userGUID],
    queryFn: () => {
      if (!userGUID) throw new Error('No user');
      return getCurrentTariff(userGUID);
    },
    enabled: Boolean(userGUID),
    staleTime: 30_000,
  });
}
